import '../styles/Loader.css';

const Loading = () => {
  return (
    <div id='loadingProgressG'>
      <div id='loadingProgressG_1' className='loadingProgressG'></div>
    </div>
  );
};
export default Loading;
